// import React from "react";
// import AgeChart from "./Charts/ageChart";
// import GenderChart from "./Charts/genderChart";
// import CommunityChart from "./Charts/communityChart";
// import AgeVsGenderChart from "./Charts/ageVsGenderChart";
// import AgeVsCommunityChart from "./Charts/ageVsCommunityChart";
// import GenderVsCommunityChart from "./Charts/genderVsCommunityChart";
// import { Skeleton } from "antd";
// import { DotChartOutlined } from "@ant-design/icons";
// export const renderCharts = (
//   selectedOption,
//   isDataAvailable,
//   graphData,
//   isLoading
// ) => {
//   if (isLoading && !graphData.length > 0 && isDataAvailable) {
//     return (
//       <div
//         className=''
//         style={{
//           height: "300px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center"
//         }}
//       >
//         <Skeleton.Node active={true}>
//           <DotChartOutlined
//             style={{
//               fontSize: 40,
//               color: "#bfbfbf"
//             }}
//           />
//         </Skeleton.Node>
//       </div>
//     );
//   }
//   switch (selectedOption) {
//     case "age":
//       return (
//         <AgeChart isDataAvailable={isDataAvailable} graphData={graphData} />
//       );
//     case "gender":
//       return (
//         <GenderChart isDataAvailable={isDataAvailable} graphData={graphData} />
//       );
//     case "community":
//       return (
//         <CommunityChart
//           isDataAvailable={isDataAvailable}
//           graphData={graphData}
//         />
//       );
//     case "ageGender":
//       return (
//         <AgeVsGenderChart
//           isDataAvailable={isDataAvailable}
//           graphData={graphData}
//         />
//       );
//     case "ageCommunity":
//       return (
//         <AgeVsCommunityChart
//           isDataAvailable={isDataAvailable}
//           graphData={graphData}
//         />
//       );
//     case "ganderCommunity":
//       return (
//         <GenderVsCommunityChart
//           isDataAvailable={isDataAvailable}
//           graphData={graphData}
//         />
//       );
//     default:
//       return null;
//   }
// };


import React from "react";
import AgeChart from "./Charts/ageChart";
import GenderChart from "./Charts/genderChart";
import AgeVsGenderChart from "./Charts/ageVsGenderChart";
import AgeVsCommunityChart from "./Charts/ageVsCommunityChart";
import GenderVsCommunityChart from "./Charts/genderVsCommunityChart";
import { Skeleton } from "antd";
import { DotChartOutlined } from "@ant-design/icons";
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Bar,
} from "recharts";

export const renderCharts = (
  selectedOption,
  isDataAvailable,
  graphData,
  isLoading
) => {
  if (isLoading && !graphData.length > 0 && isDataAvailable) {
    return (
      <div
        className=""
        style={{
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Skeleton.Node active={true}>
          <DotChartOutlined
            style={{
              fontSize: 40,
              color: "#bfbfbf",
            }}
          />
        </Skeleton.Node>
      </div>
    );
  }

  switch (selectedOption) {
    case "age":
      return (
        <AgeChart isDataAvailable={isDataAvailable} graphData={graphData} />
      );
    case "gender":
      return (
        <GenderChart isDataAvailable={isDataAvailable} graphData={graphData} />
      );
    case "community":
      // Show Y-axis = Communities, X-axis = % people, but no data
      const communityCategories = [
        { name: "Brahmins", value: 0 },
        { name: "Non-Brahmins", value: 0 },
        { name: "Muslims", value: 0 },
        { name: "SC", value: 0 },
        { name: "OBC", value: 0 },
      ];

      return (
        <div style={{ height: 300, width: "100%", position: "relative" }}>
          <ResponsiveContainer>
          <BarChart
            layout="vertical"
            data={communityCategories}
            margin={{ top: 20, right: 30, left: 30, bottom: 30 }}
          >
            <XAxis
              type="number"
              domain={[0, 100]}
              tickFormatter={(val) => `${val}%`}
              tick={{ fontSize: 12, fill: "#555" }}
              axisLine={false}  
              tickLine={false}  
              label={{
                value: "No. of People (%)",
                position: "bottom",
                offset: 20,
                style: { fontSize: 11, fill: "#000", fontWeight: 500 },
              }}
            />
            <YAxis
              dataKey="name"
              type="category"
              tick={{ fontSize: 12, fill: "#555" }}
              axisLine={false} 
              tickLine={false}  
              label={{
                value: "Community",
                angle: -90,
                position: "insideLeft",
                offset: -60,
                style: { fontSize: 11, fill: "#555", fontWeight: 500,top:"50%" },
              }}
            />
            {/* <Tooltip /> */}
            <Bar dataKey="value" fill="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "60%",
              transform: "translate(-50%, -50%)",
              fontSize: "16px",
              fontWeight: "600",
              color: "#666",
            }}
          >
            No Data Uploaded
          </div>
        </div>
      );

    case "ageGender":
      return (
        <AgeVsGenderChart
          isDataAvailable={isDataAvailable}
          graphData={graphData}
        />
      );
    case "ageCommunity":
      return (
        <AgeVsCommunityChart
          isDataAvailable={isDataAvailable}
          graphData={graphData}
        />
      );
    case "ganderCommunity":
      return (
        <GenderVsCommunityChart
          isDataAvailable={isDataAvailable}
          graphData={graphData}
        />
      );
    default:
      return null;
  }
};
